module.exports = __webpack_public_path__ + "img/pdf-export.cdc19ecd.svg";